export type FilterSessionEntry = {
  groupId: string;
  leader?: string;
};

export type FilterSessionValue = {
  groupId: string;
  value: string;
};

export const sameSessionValue = (one: FilterSessionValue, other: FilterSessionValue): boolean =>
  one.groupId === other.groupId && one.value === other.value;

export type FilterSessionState = {
  entries: FilterSessionEntry[];
  recentlyUsed: FilterSessionValue[];
};

export const EMPTY_FILTER_SESSION: FilterSessionState = { entries: [], recentlyUsed: [] };

export const SESSION_ENTRY_LIMIT = 15;
export const SESSION_LEADER_MAX_LENGTH = 64;
export const RECENTLY_USED_LIMIT = 5;

export const SESSION_FORMAT_VERSION = '2';

export const SEPARATOR = {
  SECTION: '~',
  ENTRY: '!',
  VALUE: '*',
  CHIP: '.',
} as const;
